module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-wrap"
  }, [_c('div', {
    staticClass: "row row1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "phone",
    attrs: {
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "blur": _vm.checkph,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), (_vm.phone.length > 0) ? _c('div', {
    staticClass: "clear",
    on: {
      "click": function($event) {
        _vm.phone = ""
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "xlink:href": "#icon-guanbi"
    }
  })])]) : _vm._e()]), _c('div', {
    staticClass: "row row1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "phone",
    attrs: {
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "getcode"
  }, [(_vm.getcode) ? _c('span', {
    on: {
      "click": _vm.sendcode
    }
  }, [_vm._v("获取验证码 ")]) : _c('span', [_vm._v("还剩" + _vm._s(_vm.countdown) + "秒   ")])])]), _c('div', {
    staticClass: "row row1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "password",
    staticClass: "phone",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "clear"
  }, [(_vm.password.length > 0) ? _c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.password = ""
      }
    }
  }, [_c('use', {
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "xlink:href": "#icon-guanbi"
    }
  })]) : _vm._e(), _c('span', [_vm._v("    ")]), _c('svg', {
    staticClass: "icon",
    staticStyle: {
      "font-size": "1.5rem"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.toggletype
    }
  }, [(_vm.tpsw == true) ? _c('use', {
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "xlink:href": "#icon-biyan"
    }
  }) : _c('use', {
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "xlink:href": "#icon-yanjing"
    }
  })])])]), _c('div', {
    staticClass: "row row1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rpsw),
      expression: "rpsw"
    }],
    ref: "rpsw",
    staticClass: "phone",
    attrs: {
      "type": "password",
      "placeholder": "再次确认密码"
    },
    domProps: {
      "value": (_vm.rpsw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rpsw = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "clear"
  }, [(_vm.rpsw.length > 0) ? _c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.rpsw = ""
      }
    }
  }, [_c('use', {
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "xlink:href": "#icon-guanbi"
    }
  })]) : _vm._e(), _c('span', [_vm._v("     ")]), _c('svg', {
    staticClass: "icon",
    staticStyle: {
      "font-size": "1.5rem"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.toggletype2
    }
  }, [(_vm.trpsw == true) ? _c('use', {
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "xlink:href": "#icon-biyan"
    }
  }) : _c('use', {
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "xlink:href": "#icon-yanjing"
    }
  })])])]), _c('div', {
    staticClass: "register"
  }, [_vm._v("注册                                          ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52a2a338","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/register.vue
// module id = 116
// module chunks = 0